import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {addToast, copyToClipboard, Anchor, Dialogue, Heading, Modal, Text} from '@albert-io/atomic';

import {invalidatePartialInterest} from 'resources/mandark.resource';

import ManageRosterContext from 'client/Classrooms/Classroom/Teacher/ManageRoster/ManageRoster.context';
import GenerateJoinCodeDialogue from 'client/components/GenerateJoinCodeDialogue/GenerateJoinCodeDialogue.react';
import HardCapWarningBanner from 'client/components/HardCapWarningBanner/HardCapWarningBanner.react';

import './class-code-modal.scss';

class ClassCodeModal extends React.Component {
  static propTypes = {
    handleClose: PropTypes.func
  };

  constructor() {
    super();

    this.state = {
      dialogueToShow: 'join'
    };
  }

  componentWillUnmount() {
    const hasChanges = this.context.classroom !== this.context.queries.classroom.getResource();
    if (hasChanges) {
      invalidatePartialInterest(this.context.queries.classroom.done());
      this.context.setIsReady(false);
    }
  }

  copyCode = () => {
    const classroomInviteCode = this.context.classroom.getInviteCode();

    copyToClipboard(
      classroomInviteCode,
      () => {
        addToast({
          title: 'Copied!',
          type: 'success',
          message: 'Class code was copied to your clipboard.'
        });
      },
      {
        container: global.document.getElementById('classCode')
      }
    );
  };

  static contextType = ManageRosterContext;

  render() {
    const {handleClose} = this.props;
    const {classroom} = this.context;
    return (
      <Modal
        ariaLabel='Class Code Modal'
        backdropClassName='class-code-modal__backdrop'
        handleClose={handleClose}
      >
        {({modalContentStyle}) => {
          return this.state.dialogueToShow === 'join' ? (
            <Dialogue
              inModal
              className={classnames(modalContentStyle, 'class-code-modal')}
              handleClose={handleClose}
              paddingLevel={4}
              title={`Join ${classroom.getName()}`}
              alignTitle='center'
            >
              {classroom.getSchool().isHardCap() && (
                <HardCapWarningBanner
                  rounded
                  dismissible
                  seatsRemaining={classroom.getMeta().getCountOfSchoolLicenseSeatsRemaining()}
                />
              )}
              <Dialogue.Body align='center' className='class-code-modal__body'>
                <div className='class-code-modal__invite-code-wrapper u-mar-b_5 u-mar-t_3 u-pad-lr_4 u-pad-tb_0 u-display_inline-flex u-flex-direction_column u-justify-content_center u-align-items_center'>
                  <Text bold color='black' className='class-code-modal__invite-code' id='classCode'>
                    {classroom.getInviteCode()}
                  </Text>
                  <Text as='div' className='u-mar-b_3'>
                    <Anchor
                      role='button'
                      onClick={this.copyCode}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          this.copyCode();
                        }
                      }}
                      underlined
                      tabIndex='0'
                    >
                      Copy code
                    </Anchor>
                    &nbsp;|&nbsp;
                    <Anchor
                      role='button'
                      onClick={() => this.setState({dialogueToShow: 'generate'})}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          this.setState({dialogueToShow: 'generate'});
                        }
                      }}
                      tabIndex='0'
                      underlined
                    >
                      Generate a new code
                    </Anchor>
                  </Text>
                </div>
                <Heading
                  as='div'
                  size='m'
                  className='class-code-modal__footer-text u-mar-b_1 u-mar-lr_auto u-text-align_left'
                >
                  Students:
                  <ol>
                    <li>Visit &quot;www.albert.io/classes&quot;.</li>
                    <li>Click &quot;Join Class&quot; and enter the code above.</li>
                  </ol>
                </Heading>
                <Text
                  as='p'
                  className='class-code-modal__footer-text u-text-align_left u-mar-t_7 u-mar-b_1 u-mar-lr_auto'
                  emphasis='high'
                >
                  Need help?&nbsp;
                  <Anchor
                    as='a'
                    href='https://help.albert.io/en/articles/1885052-how-do-i-join-a-classroom-as-a-student'
                    rel='noopener noreferrer'
                    target='_blank'
                    underlined
                  >
                    View our help article
                  </Anchor>
                </Text>
              </Dialogue.Body>
            </Dialogue>
          ) : (
            <GenerateJoinCodeDialogue
              className={modalContentStyle}
              classroom={this.context.classroom}
              customQuery={this.context.queries.classroom.done()}
              handleClose={() => this.setState({dialogueToShow: 'join'})}
              inModal
              onSuccess={(updatedClassroom) => {
                this.context.setClassroom(updatedClassroom);
                this.setState({dialogueToShow: 'join'});
              }}
            />
          );
        }}
      </Modal>
    );
  }
}

export default ClassCodeModal;
